import { defineStore } from 'pinia'
import { DEFAULT_LOCALE, i18n, MessageLanguages } from 'boot/i18n'
import { computed, ref } from 'vue'
import { BeforeInstallPromptEvent } from 'src/types'
import { Notify } from 'quasar'

const APP_VERSION = process.env.APP_VERSION

export const useConfigStore = defineStore('config', () => {
  // state
  let storedLanguage = localStorage.getItem('language')
  if (
    !storedLanguage ||
    !i18n.global.availableLocales.includes(storedLanguage as MessageLanguages)
  ) {
    localStorage.setItem('language', DEFAULT_LOCALE)
    storedLanguage = DEFAULT_LOCALE
  }
  const language = ref(storedLanguage)
  // @ts-expect-error Works but has invalid types
  i18n.global.locale.value = storedLanguage as MessageLanguages

  // actions
  function changeLanguage(newLanguage: MessageLanguages) {
    language.value = newLanguage
    localStorage.setItem('language', newLanguage)
    // @ts-expect-error Works but has invalid types
    i18n.global.locale.value = newLanguage
  }

  const beforeInstallEvent = ref<BeforeInstallPromptEvent>()
  const isBeforeInstallSet = computed(() => !!beforeInstallEvent.value)
  const setBeforeInstallEvent = (event: BeforeInstallPromptEvent) => {
    beforeInstallEvent.value = event
  }
  const installPWA = async () => {
    if (beforeInstallEvent.value) {
      await beforeInstallEvent.value.prompt()
      const choiceResult = await beforeInstallEvent.value.userChoice
      if (choiceResult.outcome === 'accepted') {
        // User accepted, PWA installed
        console.debug('PWA installed')
      } else {
        // User dismissed, handle accordingly
        console.debug('PWA install dismissed')
      }
      beforeInstallEvent.value = undefined
    }
  }

  const checkAppVersion = () => {
    const appVersion = localStorage.getItem('appVersion')
    if (appVersion && appVersion !== APP_VERSION) {
      localStorage.setItem('appVersion', APP_VERSION)

      const { t } = i18n.global
      Notify.create({
        message: t('app.newAppVersion.title'),
        icon: 'fa-light fa-party-horn',
        color: 'dark',
        textColor: 'white',
        iconSize: 'lg',
        timeout: 0,
        actions: [
          {
            label: t('app.newAppVersion.reload'),
            color: 'primary',
            class: 'border-radius-3 q-px-lg',
            noCaps: true,
            handler: () => {
              window.location.reload(true)
            },
          },
        ],
      })
    } else if (!appVersion) {
      localStorage.setItem('appVersion', APP_VERSION)
    }
  }

  const getStoredAppVersion = () => localStorage.getItem('appVersion')

  return {
    language,
    changeLanguage,
    isBeforeInstallSet,
    setBeforeInstallEvent,
    installPWA,
    checkAppVersion,
    getStoredAppVersion,
  }
})
